<div class="modal-header py-2 bg-dark text-light">
    <h4 class="modal-title">
        공지관리
    </h4>
</div>

<div class="modal-body">
    <form [formGroup]="formGroup" (ngSubmit)="onSubmit()">
        <div class="row">
            <div class="col">
                <div class="form-group row align-items-center"
                    [hidden]="dtgActionType === DtgActionType.create">
                    <label class="col-md-3 mb-0">
                        ID
                    </label>
                    <div class="col-md-9 position-relative">
                        <input type="text" class="form-control-sm form-control-plaintext"
                            formControlName="noticeId"
                            readonly>
                    </div>
                </div>

                <div class="form-group row align-items-center">
                    <label class="col-md-3 mb-0">
                        제목
                    </label>
                    <div class="col-md-9 position-relative">
                        <input type="text" class="form-control form-control-sm"
                            formControlName="title"
                            ngbAutofocus>
                    </div>
                </div>

                <div class="form-group row align-items-center">
                    <label class="col-md-3 mb-0">
                        공지유형
                    </label>
                    <div class="col-md-9 position-relative">
                        <select class="form-control form-control-sm w-auto"
                            formControlName="noticeType">
                            <option *ngFor="let item of listNoticeType;"
                                [ngValue]="item">
                                {{item}}
                            </option>
                        </select>
                    </div>
                </div>

                <div class="form-group row align-items-center">
                    <label class="col-md-3 mb-0">
                        팝업여부
                    </label>
                    <div class="col-md-9 position-relative">
                        <select class="form-control form-control-sm w-auto"
                            formControlName="popupYn">
                            <option [ngValue]="'Y'">사용</option>
                            <option [ngValue]="'N'">미사용</option>
                        </select>
                    </div>
                </div>

                <div class="form-group row align-items-center">
                    <label class="col-md-3 mb-0">
                        팝업 기간
                    </label>
                    <div class="col-md-9 position-relative form-inline">
                        <input type="datetime-local" class="form-control form-control-sm w-auto"
                            min="2020-01-01T00:00:00"
                            formControlName="popupDtFrom">
                        <input type="datetime-local" class="form-control form-control-sm w-auto ml-2"
                            min="2020-01-01T00:00:00"
                            formControlName="popupDtTo">
                    </div>
                </div>

                <div class="form-group row align-items-center">
                    <label class="col-md-3 mb-0">
                        공지내용
                    </label>
                    <div class="col-md-9 position-relative">
                        <textarea formControlName="content" rows="10"
                            class="form-control form-control-sm"></textarea>
                    </div>
                </div>
            </div>
        </div>
    </form>
    <!-- <div class="px-2" style="min-height: 25vh;"
        [innerHtml]="parseContent(noticeInfo.content)">
    </div> -->
</div>

<div class="modal-footer">
    <button type="button" class="btn btn-outline-success btn-sm"
        (click)="clickSave()"
        [hidden]="dtgActionType === DtgActionType.read">
        <i class="mdi mdi-content-save"></i>
        <span class="ml-1">
            저장
        </span>
    </button>
    <button type="button" class="btn btn-secondary btn-sm"
        (click)="clickCancel()">
        <i class="mdi mdi-close"></i>
        <span class="ml-1">
            닫기
        </span>
    </button>
</div>
